import { manageAccessToken } from "@/utils/Auth/Session"
import { AuthenticateUserResp } from "../Authentication/AuthUtils/Login"
import { Route, useParams } from '@tanstack/react-router';
import BrowseDevelopers from "./components/InstantMatchResults";
import { MainAppRoute } from "@/rootRoutes/MainApp";
import { useGetInstantmatchResults } from '../../../openapi/api/endpoints/default/default';

const InstantMatchPage = () => {
  const {hiringCampaignId}=useParams({from:'/allCampaigns/$hiringCampaignId'})
  const {data:applicants}=useGetInstantmatchResults({hiringCampaignId})
  return (
    <BrowseDevelopers profiles={applicants}/>
  )
}


const InstantMatchRoute = new Route({
    getParentRoute: () => MainAppRoute,
    path: "/allCampaigns/$hiringCampaignId/instantMatch",
    component: InstantMatchPage,
    beforeLoad:async ({context:{auth,queryClient}})=>{
      const session=await manageAccessToken({AuthPayload:auth as AuthenticateUserResp})
      if(!session){//no token means that token is still good
        return
      }
      const newAuthPayload={
        ...auth,
          session
        } as AuthenticateUserResp
      queryClient.setQueryData(['Auth'],newAuthPayload)
      return {
        auth:newAuthPayload
      }
    },
    })
export default InstantMatchRoute;